module.exports = __webpack_public_path__ + "static/mk11_1920x900-mobile.76aeeec8.png";